<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">D O I N G   N O T H I N G</span><br/><br/><br/></p>
<p class="center02"><span class="big2">A HISTORY OF LOAFERS, LOUNGERS, SLACKERS,</span></p>
<p class="center01"><span class="big2">AND BUMS IN AMERICA</span><br/><br/></p>
<p class="center"><span class="big1"><em>Tom Lutz</em></span><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780865477377_tp1.png"/><br/><br/><br/><br/></p>
<p class="center"><span class="small">FARRAR, STRAUS AND GIROUX<br/>NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780865477377_epub_tp_r1.vue?38611f36